import React from "react";

export const ProfileNA = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_5059_9607)">
      <path
        d="M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM22 12C22 14.398 21.15 16.599 19.738 18.324L14.52 13.106C15.43 12.369 16 11.247 16 10C16 7.794 14.206 6 12 6C10.774 6 9.645 6.568 8.899 7.486L5.675 4.262C7.4 2.85 9.602 2 11.999 2C17.513 2 22 6.486 22 12ZM13.088 11.674L10.336 8.922C10.7 8.363 11.314 8 12 8C13.103 8 14 8.897 14 10C14 10.699 13.641 11.315 13.088 11.674ZM8 21.159V19C8 18.449 8.448 18 9 18H13.758L11.758 16H9C7.346 16 6 17.346 6 19V19.981C3.577 18.154 2 15.262 2 12C2 9.602 2.85 7.401 4.262 5.676L18.325 19.738C16.6 21.15 14.398 22 12.001 22C10.579 22 9.227 21.697 8.001 21.159H8Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5059_9607">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
